import React from "react";

function SindhTimeline() {
  return (
    <div>
      <h2 className="text-h-orange py-5">
        Sindh, Pakistan’s most culturally diverse province, is the site of
        national political struggles while being host to a milieu of ethnic
        tensions, many of which coalesce in the urban centre of Karachi.
      </h2>
      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="mt-5">
            The British were keen to develop Karachi and the province as an
            artery that linked the entire subcontinent. It is this permeability
            that today is a source of fear. Given Punjab’s increasing dominance
            since the 1960s, Sindh has been gradually sidelined in terms of
            access to shared resources. Against this backdrop, demands for
            enfranchisement and equitable share of resources have been
            conceptualised as acts of subnational separatism and threats to
            national security.
          </p>
        </div>
      </div>

      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="mt-5">
            In addition, Karachi as an urban, cosmopolitan megacity is seen as
            the location where such challenges to state governance not only
            emerge but also congregate and spread out across the province’s
            interior rural regions and the wider country. Together, the
            country’s former capital and Sindh have become places where
            difference and mobility are viewed with suspicion
          </p>
        </div>
      </div>
      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="mt-5">
            Critics of the forms of corruption across the legal system will
            point to the misuse of law enforcement and court procedures that
            prevent carrying out justice. But at the root of the problem is the
            creation of a security state, a culture of fear, and the subversion
            of the legal system that this enables. In this way, any form of
            dissent can always be interpreted and subsumed as a militant threat,
            and innocent individuals such as Majid can be targeted.
          </p>
        </div>
      </div>
      <h2 className="text-h-orange py-5 text-center">
        The country’s former capital city of Karachi, and the province of Sindh,
        have become places where difference and mobility are viewed with
        suspicion.
      </h2>
    </div>
  );
}

export default SindhTimeline;
